import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import CoreMap from '@bd/bdui-coremap';
import { css } from '@bd/bdui-styles/emotion';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import PageIntroBanner from '../../components/PageIntroBanner';
import PageSection from '../../components/PageSection';
import PageSectionContent from '../../components/PageSectionContent';
import { colors } from '../../styles';

const styles = css`

`;

const communityMap = css`
  position: relative;
  height: 250px;
  width: 100%;
  z-index: 0;
  margin-bottom: 20px;
  @media (min-width: 992px) {
    width: auto;
    flex-grow: 1;
    height: 500px;
    margin-bottom: 50px;
  }
  background-color: ${colors.color3};
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup {
    margin-left: 18px;
  }
  .leaflet-popup-content {
    margin: 0;
  }
  .leaflet-popup-content-wrapper {
    border-radius: 0;
    .CommunityCard_wrapper {
      width: 100% !important;
      margin: 0;
    }
    .CommunityCard_inner  {
      padding: 0 15px;
    }
    .CommunityCard_media {
      display: none !important;
    }
    .CommunityCard_priceWrapper {
      display: none !important;
    }
    .CommunityCard_buttonWrapper {
      display: none !important;
    }
    .CommunityCard_content {
      padding: 15px;
    }
    .CommunityCard_content h4 {
      font-size: 18px;
    }
    .CommunityCard_content h5, .CommunityCard_content ul {
      display: none;
    }
  }
`;
function MapAndDirections({ page, communities }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${get(page, 'meta.name')}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <MenuAbout />
      <PageIntroBanner
        headline={get(page, 'page_intro_banner[0].headline')}
        body={get(page, 'page_intro_banner[0].text')}
      />
      <div className={styles}>
        <div className="container">
          <CoreMap
            pin={{
              iconUrl: '/images/icon-map-pin-site.svg',
              iconSize: [32, 46],
              iconAnchor: [16, 46],
            }}
            className={communityMap}
            markers={communities}
          />
        </div>
      </div>
      <PageSection fullwidth>
        {
          page.sections.map(item => (
            <PageSectionContent
              alternating
              key={item.title}
              preTitle={item.pre_title}
              title={item.title}
              body={item.body}
              media={
                <div
                  className="ContentBanner_resultMediaInner"
                  style={{ backgroundImage: `url('${buildThumbnailUrl(get(item, 'image.contentUrl'), { width: 1200, height: 1200 })}')` }}
                />
              }
            />
          ))
        }
      </PageSection>
    </PageWrapper>
  );
}

MapAndDirections.propTypes = {
  page: PropTypes.object.isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  page: 'maps_and_directions',
  communities: true,
})(MapAndDirections);



// WEBPACK FOOTER //
// ./src/pages/MapAndDirections/index.js